import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, XCircle, ChevronDown, ChevronUp, Star, ShieldCheck, Clock, BookOpen, Download, Trophy, ArrowRight, ShoppingCart, Check } from 'lucide-react';
const FAKE_PURCHASES = [{
  name: 'Martín',
  city: 'Buenos Aires'
}, {
  name: 'Carlos',
  city: 'Córdoba'
}, {
  name: 'Federico',
  city: 'Rosario'
}, {
  name: 'Sofía',
  city: 'Mendoza'
}, {
  name: 'Diego',
  city: 'Santa Fe'
}, {
  name: 'Claudia',
  city: 'Tucumán'
}, {
  name: 'Juan',
  city: 'La Plata'
}, {
  name: 'Pablo',
  city: 'Mar del Plata'
}, {
  name: 'Lucas',
  city: 'Bahía Blanca'
}, {
  name: 'Mariano',
  city: 'Neuquén'
}];
function PurchasePopup() {
  const [purchase, setPurchase] = useState<{
    name: string;
    city: string;
  } | null>(null);
  useEffect(() => {
    const showPopup = () => {
      const randomPurchase = FAKE_PURCHASES[Math.floor(Math.random() * FAKE_PURCHASES.length)];
      setPurchase(randomPurchase);
      setTimeout(() => {
        setPurchase(null);
      }, 5000);
    };
    const interval = setInterval(() => {
      showPopup();
    }, 30000);
    const initial = setTimeout(showPopup, 3000);
    return () => {
      clearInterval(interval);
      clearTimeout(initial);
    };
  }, []);
  return <AnimatePresence data-id="element-1">
      {purchase && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -20
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-gray-200 p-4 flex items-center gap-4 max-w-sm" data-id="element-2">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-3">
            <ShoppingCart className="w-5 h-5 text-green-600" data-id="element-4" />
          </div>
          <div data-id="element-5">
            <p className="text-sm text-gray-800" data-id="element-6">
              <span className="font-bold" data-id="element-7">{purchase.name}</span> de{' '}
              {purchase.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-8">
              Acaba de comprar el Megapack Elite
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 py-4" data-id="element-9">
      <button className="w-full flex justify-between items-center text-left font-bold text-lg text-gray-800 focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-10">
        {question}
        {isOpen ? <ChevronUp className="w-5 h-5 text-orange-500 flex-shrink-0 ml-4" data-id="element-11" /> : <ChevronDown className="w-5 h-5 text-orange-500 flex-shrink-0 ml-4" data-id="element-12" />}
      </button>
      <AnimatePresence data-id="element-13">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-14">
            <p className="pt-4 text-gray-600 leading-relaxed" data-id="element-15">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex justify-center items-center gap-4 text-3xl md:text-5xl font-black text-red-600 my-6" data-id="element-16">
      <div className="flex flex-col items-center" data-id="element-17">
        <span data-id="element-18">{String(timeLeft.hours).padStart(2, '0')}</span>
        <span className="text-xs text-gray-500 font-normal uppercase tracking-wider mt-1" data-id="element-19">
          HS
        </span>
      </div>
      <span className="text-gray-400 mb-6" data-id="element-20">:</span>
      <div className="flex flex-col items-center" data-id="element-21">
        <span data-id="element-22">{String(timeLeft.minutes).padStart(2, '0')}</span>
        <span className="text-xs text-gray-500 font-normal uppercase tracking-wider mt-1" data-id="element-23">
          MIN
        </span>
      </div>
      <span className="text-gray-400 mb-6" data-id="element-24">:</span>
      <div className="flex flex-col items-center" data-id="element-25">
        <span data-id="element-26">{String(timeLeft.seconds).padStart(2, '0')}</span>
        <span className="text-xs text-gray-500 font-normal uppercase tracking-wider mt-1" data-id="element-27">
          SEG
        </span>
      </div>
    </div>;
}
const PACKS = [{
  emoji: '📗',
  name: 'PACK PROFESIONAL',
  sub: '12 Tomos + 6 Bonus',
  oldPrice: '$35.990',
  price: '$18.990',
  caption: 'Todos los tomos y los 6 Bonus estratégicos incluidos.',
  cta: 'QUIERO EL PACK PROFESIONAL'
}, {
  emoji: '🏆',
  name: 'MEGAPACK ELITE',
  sub: '12 Tomos + 6 Bonus + 2 Ebooks Elite',
  oldPrice: '$44.990',
  price: '$27.990',
  caption: 'La opción más elegida por entrenadores de básquet argentinos.',
  cta: 'SÍ, QUIERO EL MEGAPACK ELITE',
  featured: true,
  badge: 'MÁS ELEGIDO',
  savings: 'AHORRÁS $17.000'
}];
function PricingCheckout() {
  const [selected, setSelected] = useState(1); // Megapack Elite por defecto
  const active = PACKS[selected];
  return <div className="max-w-2xl mx-auto bg-white rounded-3xl shadow-xl border border-gray-100 p-6 md:p-10" data-id="element-28">
      <div className="text-center mb-8" data-id="element-29">
        <h3 className="text-3xl md:text-4xl font-black text-gray-900 mb-3" data-id="element-30">
          Elegí tu Pack:
        </h3>
        <p className="text-gray-500 text-lg" data-id="element-31">
          Todas las opciones incluyen los 6 Bonus estratégicos
        </p>
      </div>

      <div className="space-y-4" data-id="element-32">
        {PACKS.map((pack, i) => {
        const isSelected = selected === i;
        return <button key={i} type="button" onClick={() => setSelected(i)} aria-pressed={isSelected} className={`w-full text-left rounded-2xl border-2 p-5 flex items-start gap-4 transition-all ${isSelected ? 'border-orange-500 bg-orange-50' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-33">
              {/* Radio */}
              <span className={`mt-1 flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-orange-500' : 'border-gray-300'}`} data-id="element-34">
                {isSelected && <span className="w-3 h-3 rounded-full bg-orange-500" data-id="element-35" />}
              </span>

              <div className="flex-1 min-w-0" data-id="element-36">
                <div className="flex items-start justify-between gap-3 flex-wrap" data-id="element-37">
                  <div className="min-w-0" data-id="element-38">
                    <h4 className="text-lg md:text-xl font-black text-gray-900 flex items-center gap-2" data-id="element-39">
                      <span className="text-2xl" data-id="element-40">{pack.emoji}</span>
                      {pack.name}
                    </h4>
                    {pack.featured && <div className="flex flex-wrap gap-2 mt-2" data-id="element-41">
                        <span className="inline-flex items-center gap-1 bg-yellow-400 text-gray-900 text-xs font-black px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-42">
                          <Star className="w-3 h-3 fill-current" data-id="element-43" /> {pack.badge}
                        </span>
                        <span className="inline-block bg-orange-100 text-orange-700 text-xs font-black px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-44">
                          {pack.savings}
                        </span>
                      </div>}
                    <p className="text-gray-500 text-sm mt-2" data-id="element-45">{pack.sub}</p>
                  </div>

                  <div className="text-right flex-shrink-0" data-id="element-46">
                    <span className="block text-gray-400 line-through text-sm" data-id="element-47">
                      {pack.oldPrice}
                    </span>
                    <span className={`block text-2xl md:text-3xl font-black ${isSelected ? 'text-orange-600' : 'text-gray-900'}`} data-id="element-48">
                      {pack.price}
                    </span>
                  </div>
                </div>
              </div>
            </button>;
      })}
      </div>

      <button className="mt-8 w-full bg-orange-500 hover:bg-orange-600 text-white font-black text-lg md:text-xl py-5 rounded-2xl transition-all shadow-[0_0_25px_rgba(249,115,22,0.35)] hover:scale-[1.02] transform flex flex-col items-center" data-id="element-49">
        <span data-id="element-50">{active.cta}</span>
        <ArrowRight className="w-5 h-5 mt-1" data-id="element-51" />
      </button>

      <p className="text-center text-gray-400 italic mt-5" data-id="element-52">{active.caption}</p>
    </div>;
}
export function LandingPage() {
  const scrollToPricing = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900 selection:bg-orange-500 selection:text-white" data-id="element-53">
      <PurchasePopup data-id="element-54" />

      {/* SECCIÓN 1 — HERO */}
      <section className="bg-slate-900 text-white px-4 pb-16 md:pt-20 md:pb-24 relative overflow-hidden" data-id="element-55">
        <div className="absolute inset-0 opacity-20 bg-[url('https://images.unsplash.com/photo-1546519638-68e109498ffc?auto=format&fit=crop&w=1000&q=45')] bg-cover bg-center mix-blend-overlay" data-id="element-56"></div>

        {/* Above-the-fold: encaja en una pantalla de iPhone hasta el primer CTA inclusive */}
        <div className="relative z-10 max-w-5xl mx-auto text-center min-h-[100svh] md:min-h-0 flex flex-col items-center justify-center py-4 md:py-0" data-id="element-57">
          <div className="inline-block bg-orange-500 text-white font-bold px-4 py-1 rounded-full text-xs sm:text-sm mb-3 md:mb-6 tracking-wide uppercase" data-id="element-58">
            PROFE LISTO · BÁSQUET 360
          </div>
          <h1 className="text-3xl sm:text-5xl md:text-7xl font-black leading-tight mb-3 md:mb-6 tracking-tight" data-id="element-59">
            Todo tu año de básquet <br className="hidden md:block" data-id="element-60" />
            <span className="text-orange-500" data-id="element-61">resuelto de una vez.</span>
          </h1>

          {/* Imagen principal del producto */}
          <div className="mb-3 md:mb-8 flex justify-center" data-id="element-62">
            <img src="https://cdn.magicpatterns.com/uploads/sAfix7qKipiBgjgdiNFfeW/creativos_ebook_profelisto_(11).png" alt="Megapack BÁSQUET 360 — Colección completa de 12 Tomos, 6 Bonus y 2 Ebooks Elite" className="w-full max-w-xl max-h-[34vh] md:max-h-none object-contain drop-shadow-2xl" width={576} height={576} fetchPriority="high" decoding="async" data-id="element-63" />
          </div>

          <p className="text-sm sm:text-lg md:text-2xl text-gray-300 mb-4 md:mb-10 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-64">
            Megapack BÁSQUET 360 — El sistema completo de planificaciones y
            sesiones listas para usar para el entrenador de básquet argentino.
          </p>

          <div className="hidden sm:flex flex-wrap justify-center gap-4 mb-10 text-sm md:text-base font-medium text-gray-300" data-id="element-65">
            <span className="flex items-center gap-2 bg-slate-800/50 px-4 py-2 rounded-full border border-slate-700" data-id="element-66">
              <BookOpen className="w-4 h-4 text-orange-500" data-id="element-67" /> 📄 PDF
            </span>
            <span className="flex items-center gap-2 bg-slate-800/50 px-4 py-2 rounded-full border border-slate-700" data-id="element-68">
              <Clock className="w-4 h-4 text-orange-500" data-id="element-69" /> ⚡ Acceso Inmediato
            </span>
            <span className="flex items-center gap-2 bg-slate-800/50 px-4 py-2 rounded-full border border-slate-700" data-id="element-70">
              <Trophy className="w-4 h-4 text-orange-500" data-id="element-71" /> 📚 12 Tomos + 6
              Bonus + 2 Ebooks Elite
            </span>
          </div>

          <a href="#pricing" onClick={scrollToPricing} className="inline-flex items-center justify-center gap-3 bg-orange-500 hover:bg-orange-600 text-white font-black text-base sm:text-xl md:text-2xl py-4 md:py-5 px-6 md:px-10 rounded-xl transition-all transform hover:scale-105 shadow-[0_0_40px_rgba(249,115,22,0.4)] w-full md:w-auto" data-id="element-72">
            🏀 QUIERO MI BÁSQUET 360 AHORA
          </a>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 mt-4 md:mt-8 text-xs sm:text-sm text-gray-400" data-id="element-73">
            <span className="flex items-center gap-2" data-id="element-74">
              <ShieldCheck className="w-4 h-4" data-id="element-75" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-76">
              <CheckCircle2 className="w-4 h-4" data-id="element-77" /> Pago seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-78">
              <ShoppingCart className="w-4 h-4" data-id="element-79" /> Tarjetas y transferencia
            </span>
          </div>
        </div>

        {/* Stats Table / Bar — debajo del fold */}
        <div className="relative z-10 max-w-5xl mx-auto" data-id="element-80">
          <div className="mt-10 md:mt-16 bg-slate-800/80 backdrop-blur-sm border border-slate-700 rounded-2xl p-6 max-w-4xl mx-auto flex flex-wrap justify-around items-center gap-6" data-id="element-81">
            <div className="text-center" data-id="element-82">
              <div className="text-3xl font-black text-white" data-id="element-83">+300</div>
              <div className="text-sm text-gray-400 uppercase tracking-wider mt-1" data-id="element-84">
                profes confían
              </div>
            </div>
            <div className="w-px h-12 bg-slate-700 hidden md:block" data-id="element-85"></div>
            <div className="text-center" data-id="element-86">
              <div className="text-3xl font-black text-white" data-id="element-87">12+6</div>
              <div className="text-sm text-gray-400 uppercase tracking-wider mt-1" data-id="element-88">
                Tomos + Bonus
              </div>
            </div>
            <div className="w-px h-12 bg-slate-700 hidden md:block" data-id="element-89"></div>
            <div className="text-center" data-id="element-90">
              <div className="text-3xl font-black text-white flex items-center justify-center gap-1" data-id="element-91">
                4.9/5{' '}
                <Star className="w-6 h-6 text-yellow-400 fill-yellow-400" data-id="element-92" />
              </div>
              <div className="text-sm text-gray-400 uppercase tracking-wider mt-1" data-id="element-93">
                calificación
              </div>
            </div>
            <div className="w-px h-12 bg-slate-700 hidden md:block" data-id="element-94"></div>
            <div className="text-center" data-id="element-95">
              <div className="text-3xl font-black text-white" data-id="element-96">🇦🇷</div>
              <div className="text-sm text-gray-400 uppercase tracking-wider mt-1" data-id="element-97">
                Argentina
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 2 — TESTIMONIOS INICIALES */}
      <section className="py-16 bg-white px-4" data-id="element-98">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-99">
          <div className="bg-blue-50 p-6 rounded-2xl border border-blue-100 relative" data-id="element-100">
            <div className="flex text-yellow-400 mb-4" data-id="element-101">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-102" />)}
            </div>
            <p className="text-gray-700 italic mb-6" data-id="element-103">
              "Organicé todo el mes en una tarde. Nunca más llego al
              entrenamiento sin saber qué dar."
            </p>
            <div className="flex items-center gap-3" data-id="element-104">
              <div className="w-10 h-10 bg-blue-200 rounded-full flex items-center justify-center font-bold text-blue-800" data-id="element-105">
                MP
              </div>
              <div data-id="element-106">
                <div className="font-bold text-gray-900" data-id="element-107">
                  Martín P., Buenos Aires
                </div>
                <div className="text-xs text-gray-500" data-id="element-108">
                  Entrenador de Básquet en Club de Barrio
                </div>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 p-6 rounded-2xl border border-blue-100 relative" data-id="element-109">
            <div className="flex text-yellow-400 mb-4" data-id="element-110">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-111" />)}
            </div>
            <p className="text-gray-700 italic mb-6" data-id="element-112">
              "Mis alumnos de nivel inicial mejoraron el bote y el pase desde la
              primera semana con el Tomo 1."
            </p>
            <div className="flex items-center gap-3" data-id="element-113">
              <div className="w-10 h-10 bg-blue-200 rounded-full flex items-center justify-center font-bold text-blue-800" data-id="element-114">
                CG
              </div>
              <div data-id="element-115">
                <div className="font-bold text-gray-900" data-id="element-116">
                  Carlos G., Córdoba
                </div>
                <div className="text-xs text-gray-500" data-id="element-117">
                  Entrenador en Academia Privada
                </div>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 p-6 rounded-2xl border border-blue-100 relative" data-id="element-118">
            <div className="flex text-yellow-400 mb-4" data-id="element-119">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-120" />)}
            </div>
            <p className="text-gray-700 italic mb-6" data-id="element-121">
              "Antes tardaba una hora armando la clase. Ahora son 5 minutos."
            </p>
            <div className="flex items-center gap-3" data-id="element-122">
              <div className="w-10 h-10 bg-blue-200 rounded-full flex items-center justify-center font-bold text-blue-800" data-id="element-123">
                FR
              </div>
              <div data-id="element-124">
                <div className="font-bold text-gray-900" data-id="element-125">
                  Federico R., Rosario
                </div>
                <div className="text-xs text-gray-500" data-id="element-126">
                  Entrenador Independiente
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 3 — DOLOR */}
      <section className="py-20 bg-white px-4 border-t border-gray-100" data-id="element-127">
        <div className="max-w-4xl mx-auto" data-id="element-128">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-gray-900" data-id="element-129">
            Si sos profe de básquet, esto te va a sonar conocido:
          </h2>

          <div className="space-y-4 mb-16" data-id="element-130">
            {['Llegás al entrenamiento sin saber exactamente qué ejercicios vas a dar', 'Tus alumnos no progresan porque no hay un orden claro de contenidos', 'Tenés grupos con niveles mezclados y no sabés cómo manejarlos sin volverte loco', 'Cuando hay feriado o ausencia, perdés la continuidad del proceso de aprendizaje', 'No podés justificar un aumento de cuota porque no tenés nada sistematizado que mostrar', 'Llegás a casa después del entrenamiento agotado mentalmente de tanto improvisar', 'Los padres no ven resultados concretos y empiezan a cuestionar tu trabajo', 'Sabés que tus alumnos podrían mejorar mucho más si tuvieras una progresión real'].map((pain, i) => <div key={i} className="flex items-start gap-4 p-4 rounded-xl hover:bg-red-50 transition-colors" data-id="element-131">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-132" />
                <p className="text-lg text-gray-700 font-medium" data-id="element-133">{pain}</p>
              </div>)}
          </div>

          <div className="text-center bg-slate-50 p-10 rounded-3xl border border-slate-200" data-id="element-134">
            <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-8 italic" data-id="element-135">
              "¿Cuántos entrenamientos más vas a improvisar?"
            </h3>
            <a href="#pricing" onClick={scrollToPricing} className="inline-flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg md:text-xl py-4 px-8 rounded-xl transition-all shadow-lg w-full md:w-auto" data-id="element-136">
              👉 BASTA DE IMPROVISAR — QUIERO MI BÁSQUET 360
            </a>
          </div>
        </div>
      </section>

      {/* SECCIÓN 4 — CREDIBILIDAD */}
      <section className="py-20 bg-slate-900 text-white px-4" data-id="element-137">
        <div className="max-w-5xl mx-auto text-center" data-id="element-138">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-500/20 rounded-full mb-6" data-id="element-139">
            <Trophy className="w-8 h-8 text-orange-500" data-id="element-140" />
          </div>
          <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-141">
            El Sistema N°1 para Entrenadores de Básquet Argentinos
          </h2>
          <p className="text-xl text-gray-400 mb-12" data-id="element-142">
            BÁSQUET 360 — Colección Completa
          </p>

          <div className="bg-slate-800 border border-slate-700 rounded-3xl p-8 md:p-12" data-id="element-143">
            <h3 className="text-2xl md:text-3xl font-bold text-orange-500 mb-2" data-id="element-144">
              12 Tomos + 6 Bonus + 2 Ebooks Elite
            </h3>
            <p className="text-xl text-white mb-10" data-id="element-145">
              Todo resuelto. Todos los niveles.
            </p>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-8 text-left" data-id="element-146">
              <div className="flex flex-col items-center text-center" data-id="element-147">
                <div className="text-4xl font-black text-white mb-2" data-id="element-148">+280</div>
                <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-149">
                  páginas
                </div>
              </div>
              <div className="flex flex-col items-center text-center" data-id="element-150">
                <div className="text-4xl font-black text-white mb-2" data-id="element-151">+150</div>
                <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-152">
                  ejercicios graficados
                </div>
              </div>
              <div className="flex flex-col items-center text-center" data-id="element-153">
                <div className="text-4xl font-black text-white mb-2" data-id="element-154">Todos</div>
                <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-155">
                  los niveles
                </div>
              </div>
              <div className="flex flex-col items-center text-center" data-id="element-156">
                <div className="text-4xl font-black text-white mb-2" data-id="element-157">100%</div>
                <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-158">
                  listo para usar
                </div>
              </div>
              <div className="flex flex-col items-center text-center" data-id="element-159">
                <div className="text-4xl font-black text-white mb-2" data-id="element-160">Full</div>
                <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-161">
                  diagramas de cancha
                </div>
              </div>
              <div className="flex flex-col items-center text-center" data-id="element-162">
                <div className="text-4xl font-black text-white mb-2" data-id="element-163">A a Z</div>
                <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-164">
                  Del iniciante al avanzado
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 5 — LOS 12 TOMOS */}
      <section className="py-20 bg-gray-50 px-4" data-id="element-165">
        <div className="max-w-6xl mx-auto" data-id="element-166">
          <div className="text-center mb-16" data-id="element-167">
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-168">
              Los 12 Tomos Completos
            </h2>
            <p className="text-xl text-gray-600" data-id="element-169">
              Sesiones graficadas · Por nivel y objetivo · Listo para usar
              mañana
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-170">
            {[{
            num: 1,
            title: 'Niños Inicial — Primeras Semanas',
            desc: 'El primer contacto con el básquet. Familiarización con el balón, bote básico y confianza en la cancha.',
            color: 'bg-blue-600'
          }, {
            num: 2,
            title: 'Niños Inicial — Consolidación',
            desc: 'Pases, bandeja y fundamentos básicos consolidados. El pibe que no sabía agarrar una pelota empieza a jugar de verdad.',
            color: 'bg-blue-600'
          }, {
            num: 3,
            title: 'Niños Intermedio — Técnica Individual',
            desc: 'Triple amenaza, penetración, cortes V y L. El jugador empieza a tomar decisiones solo.',
            color: 'bg-blue-600'
          }, {
            num: 4,
            title: 'Niños Intermedio — Juego Colectivo',
            desc: 'Pick and roll, motion offense y defensa zonal. El básquet empieza a verse como un deporte de equipo.',
            color: 'bg-blue-600'
          }, {
            num: 5,
            title: 'Niños Avanzado — Sistemas',
            desc: 'Horns, Flex, Box and One y Triangle and Two. Los sistemas que usan los equipos de verdad, adaptados para formativas.',
            color: 'bg-blue-600'
          }, {
            num: 6,
            title: 'Niños Avanzado — Competencia',
            desc: 'Princeton, presión full court y gestión del partido. El cierre del ciclo de formación infantil.',
            color: 'bg-blue-600'
          }, {
            num: 7,
            title: 'Adolescentes y Adultos Inicial',
            desc: 'El adulto que nunca jugó o volvió después de años. Fundamentos sin presión, con progresión real.',
            color: 'bg-green-600'
          }, {
            num: 8,
            title: 'Adolescentes y Adultos Intermedio',
            desc: 'Tiro en suspensión, floater, pick and roll avanzado. El jugador amateur que quiere mejorar de verdad.',
            color: 'bg-green-600'
          }, {
            num: 9,
            title: 'Adolescentes y Adultos Avanzado',
            desc: 'Sistemas ofensivos y defensivos de alto nivel adaptados para básquet amateur competitivo.',
            color: 'bg-green-600'
          }, {
            num: 10,
            title: 'Adolescentes y Adultos — Competencia',
            desc: 'Plan de juego, scouting, libro de jugadas y gestión del banco. El entrenador que gana partidos.',
            color: 'bg-green-600'
          }, {
            num: 11,
            title: 'Adultos Mayores',
            desc: 'Básquet adaptado para cuerpos maduros. Movilidad, coordinación y bienestar físico con pelota.',
            color: 'bg-orange-500'
          }, {
            num: 12,
            title: 'Lesiones y Casos Especiales',
            desc: 'Protocolos para rodilla, tobillo, espalda y hombro. Nunca más improvisés con la salud de tus alumnos.',
            color: 'bg-orange-500'
          }].map((tomo, i) => <div key={i} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200 hover:shadow-md transition-shadow" data-id="element-171">
                <div className={`inline-block px-3 py-1 rounded-md text-white text-sm font-bold mb-4 ${tomo.color}`} data-id="element-172">
                  TOMO {tomo.num}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-173">
                  {tomo.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-174">{tomo.desc}</p>
              </div>)}
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-gray-700 font-medium bg-white p-6 rounded-2xl border border-gray-200" data-id="element-175">
            <span className="flex items-center gap-2" data-id="element-176">
              <span className="text-xl" data-id="element-177">✏️</span> Ejercicios graficados en cada
              tomo
            </span>
            <span className="flex items-center gap-2" data-id="element-178">
              <span className="text-xl" data-id="element-179">⚡</span> Sistema "Abrí y Entrenás"
            </span>
            <span className="flex items-center gap-2" data-id="element-180">
              <span className="text-xl" data-id="element-181">📋</span> Fichas listas para imprimir
            </span>
            <span className="flex items-center gap-2" data-id="element-182">
              <span className="text-xl" data-id="element-183">🇦🇷</span> Contenido 100% adaptado al
              básquet argentino
            </span>
          </div>
        </div>
      </section>

      {/* SECCIÓN 6 — LOS 6 BONUS */}
      <section className="py-20 bg-stone-50 px-4" data-id="element-184">
        <div className="max-w-6xl mx-auto" data-id="element-185">
          <div className="text-center mb-14" data-id="element-186">
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-187">
              + 6 Regalos Estratégicos
            </h2>
            <p className="text-xl text-gray-500 mb-8" data-id="element-188">
              Incluidos sin costo extra · En todas las opciones
            </p>
            <div className="inline-flex items-center gap-2 bg-orange-500 text-white font-bold text-lg px-8 py-3 rounded-full shadow-md" data-id="element-189">
              🎁 GRATIS POR EL DÍA DE HOY
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-190">
            {[{
            icon: '🎯',
            title: 'Bonus 1 — NIVELÓMETRO 360™',
            cover: 'NIVELÓMETRO 360™',
            desc: 'Ubicá a cualquier alumno nuevo en su nivel real en menos de 5 minutos. Sin adivinar. Sin mezclar niveles. Sin perder clases.',
            cls: 'from-emerald-600 to-emerald-700',
            spine: 'bg-emerald-800'
          }, {
            icon: '💪',
            title: 'Bonus 2 — FÍSICO EXPRESS™',
            cover: 'FÍSICO EXPRESS™',
            desc: 'Rutinas de preparación física de 15 minutos integradas a tu clase. Más rendimiento. Menos lesiones. Sin perder tiempo de cancha.',
            cls: 'from-blue-600 to-blue-700',
            spine: 'bg-blue-800'
          }, {
            icon: '🥗',
            title: 'Bonus 3 — NUTRICIÓN Y RENDIMIENTO™',
            cover: 'NUTRICIÓN Y RENDIMIENTO™',
            desc: "Qué comer y tomar antes, durante y después de la clase. Para que el alumno no 'se muera' a los 30 minutos.",
            cls: 'from-amber-500 to-amber-600',
            spine: 'bg-amber-700'
          }, {
            icon: '🛠️',
            title: 'Bonus 4 — KIT DE SUPERVIVENCIA™',
            cover: 'KIT DE SUPERVIVENCIA™',
            desc: 'Protocolos de emergencia para grupos mixtos, sin materiales, con 20 minutos de clase y alumnos de mal humor. El manual para cuando todo sale mal.',
            cls: 'from-red-600 to-red-700',
            spine: 'bg-red-800'
          }, {
            icon: '📅',
            title: 'Bonus 5 — PACK DE ORGANIZACIÓN SEMANAL™',
            cover: 'ORGANIZACIÓN SEMANAL™',
            desc: 'Planillas de cobro, asistencia, inventario y gestión. Dominá tu semana como entrenador en 15 minutos cada domingo.',
            cls: 'from-violet-600 to-violet-700',
            spine: 'bg-violet-800'
          }, {
            icon: '🎯',
            title: 'Bonus 6 — VENTA IRRESISTIBLE™',
            cover: 'VENTA IRRESISTIBLE™',
            desc: 'Scripts de WhatsApp para captar alumnos, cómo hablar con los padres y cómo evitar el abandono al segundo mes.',
            cls: 'from-teal-600 to-teal-700',
            spine: 'bg-teal-800'
          }].map((bonus, i) => <div key={i} className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 flex flex-col items-center text-center" data-id="element-191">
                {/* Portada ilustrada tipo libro/ebook */}
                <div className="mb-6 [perspective:1000px]" data-id="element-192">
                  <div className="relative w-40 h-56 rounded-r-xl rounded-l-md shadow-xl overflow-hidden transition-transform duration-300 hover:[transform:rotateY(-8deg)]" data-id="element-193">
                    <div className={`absolute inset-0 bg-gradient-to-br ${bonus.cls}`} data-id="element-194"></div>
                    <div className={`absolute left-0 top-0 bottom-0 w-3 ${bonus.spine}`} data-id="element-195"></div>
                    <div className="relative h-full flex flex-col justify-between p-4 pl-6 text-white" data-id="element-196">
                      <div className="text-3xl" data-id="element-197">{bonus.icon}</div>
                      <div className="text-lg font-black leading-tight text-left" data-id="element-198">
                        Bonus {i + 1}
                      </div>
                      <div data-id="element-199">
                        <div className="h-px w-full bg-white/30 mb-3" data-id="element-200"></div>
                        <div className="text-[10px] font-bold tracking-wider uppercase text-white/90 text-left leading-snug" data-id="element-201">
                          {bonus.cover}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <span className="inline-block bg-green-100 text-green-700 text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-wider mb-4" data-id="element-202">
                  GRATIS
                </span>

                <h3 className="text-xl font-black text-gray-900 mb-3 flex items-center justify-center gap-2 flex-wrap" data-id="element-203">
                  <span className="text-2xl" data-id="element-204">{bonus.icon}</span>
                  {bonus.title}
                </h3>
                <p className="text-gray-500 leading-relaxed" data-id="element-205">{bonus.desc}</p>
              </div>)}
          </div>

          <div className="mt-14 text-center" data-id="element-206">
            <a href="#pricing" onClick={scrollToPricing} className="inline-flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-bold text-xl py-4 px-8 rounded-xl transition-all shadow-lg w-full md:w-auto" data-id="element-207">
              QUIERO ESTOS BONUS GRATIS AHORA
            </a>
          </div>
        </div>
      </section>

      {/* SECCIÓN 7 — PRECIO Y OFERTA */}
      <section id="pricing" className="py-24 bg-gray-50 px-4" data-id="element-208">
        <div className="max-w-6xl mx-auto" data-id="element-209">
          <div className="text-center mb-12" data-id="element-210">
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-211">
              ⏰ PRECIO DE LANZAMIENTO
            </h2>
            <p className="text-xl text-gray-600 uppercase tracking-wider font-bold" data-id="element-212">
              OFERTA POR TIEMPO LIMITADO
            </p>

            <CountdownTimer data-id="element-213" />

            <div className="inline-block bg-red-100 text-red-700 font-bold px-6 py-2 rounded-full" data-id="element-214">
              🔴 El precio sube cuando termina el contador
            </div>
          </div>

          <PricingCheckout data-id="element-215" />

          <div className="flex flex-wrap justify-center gap-8 mt-12 text-sm text-gray-500 font-medium" data-id="element-216">
            <span className="flex items-center gap-2" data-id="element-217">
              <ShieldCheck className="w-5 h-5 text-gray-400" data-id="element-218" /> Pago seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-219">
              <Clock className="w-5 h-5 text-gray-400" data-id="element-220" /> Acceso en 5 min
            </span>
            <span className="flex items-center gap-2" data-id="element-221">
              <ShieldCheck className="w-5 h-5 text-gray-400" data-id="element-222" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-223">
              <ShoppingCart className="w-5 h-5 text-gray-400" data-id="element-224" /> Tarjeta ·
              Transferencia
            </span>
          </div>
        </div>
      </section>

      {/* SECCIÓN 8 — LOS 2 EBOOKS ELITE */}
      <section className="py-20 bg-white px-4 border-t border-gray-100" data-id="element-225">
        <div className="max-w-4xl mx-auto" data-id="element-226">
          <div className="text-center mb-16" data-id="element-227">
            <h2 className="text-4xl font-black text-gray-900 mb-4" data-id="element-228">
              ¿Qué agrega el Megapack Elite?
            </h2>
            <p className="text-xl text-gray-600" data-id="element-229">
              Por solo $9.000 más, llevás tu enseñanza al siguiente nivel.
            </p>
          </div>

          <div className="space-y-8" data-id="element-230">
            <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-8 flex flex-col md:flex-row gap-6 items-start" data-id="element-231">
              <div className="text-5xl flex-shrink-0" data-id="element-232">📅</div>
              <div data-id="element-233">
                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-234">
                  Elite 1 — Planificador Anual Día por Día
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-235">
                  Tu cronograma de sesiones de enero a diciembre. Sabé
                  exactamente qué dar el 15 de abril o el 10 de octubre sin
                  tener que pensar. La libertad mental total del profe
                  organizado.
                </p>
                <p className="text-gray-900 font-bold italic" data-id="element-236">
                  "Nunca más te vas a acostar un domingo pensando '¿qué carajo
                  les doy mañana?'"
                </p>
              </div>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-8 flex flex-col md:flex-row gap-6 items-start" data-id="element-237">
              <div className="text-5xl flex-shrink-0" data-id="element-238">🏆</div>
              <div data-id="element-239">
                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-240">
                  Elite 2 — Entrenamiento para Competencia
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-241">
                  El manual para detectar talentos, armar tu equipo y llevar
                  basquetbolistas al podio. Pasá de ser el profe que cuida gente
                  en la cancha al entrenador que forma campeones.
                </p>
                <p className="text-gray-900 font-bold italic" data-id="element-242">
                  "Tus jugadores van a empezar a competir de verdad. Y el club
                  va a empezar a verte diferente."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 9 — TABLA COMPARATIVA */}
      <section className="py-20 bg-slate-50 px-4" data-id="element-243">
        <div className="max-w-4xl mx-auto" data-id="element-244">
          <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-12" data-id="element-245">
            ¿Cuánto cuesta NO tenerlo?
          </h2>

          <div className="overflow-x-auto bg-white rounded-2xl shadow-sm border border-gray-200" data-id="element-246">
            <table className="w-full text-left border-collapse" data-id="element-247">
              <thead data-id="element-248">
                <tr data-id="element-249">
                  <th className="p-4 border-b border-gray-200 bg-gray-50 text-gray-500 font-medium w-1/3" data-id="element-250"></th>
                  <th className="p-4 border-b border-gray-200 bg-red-50 text-red-700 font-bold text-center w-1/3" data-id="element-251">
                    Sin BÁSQUET 360
                  </th>
                  <th className="p-4 border-b border-gray-200 bg-green-50 text-green-700 font-bold text-center w-1/3" data-id="element-252">
                    Con BÁSQUET 360
                  </th>
                </tr>
              </thead>
              <tbody className="text-gray-700" data-id="element-253">
                {[{
                label: 'Preparación de cada clase',
                bad: '1 hora desde cero',
                good: '5 minutos. Todo listo.'
              }, {
                label: 'Progresión de los alumnos',
                bad: 'Improvisada sin orden',
                good: '+150 sesiones graficadas por nivel'
              }, {
                label: 'Grupos con niveles mixtos',
                bad: 'Caos y frustración',
                good: 'Estructura clara para cada nivel'
              }, {
                label: 'Lesión de un alumno',
                bad: 'Improvisás y rezás',
                good: 'Protocolo listo en el Tomo 12'
              }, {
                label: 'Justificar el precio de la cuota',
                bad: 'No tenés argumentos',
                good: 'Mostrás la planificación anual'
              }, {
                label: 'Domingos a la noche',
                bad: 'Pensando qué dar el lunes',
                good: 'El año ya está resuelto'
              }, {
                label: 'Abandono de alumnos',
                bad: 'Sin herramientas para retener',
                good: 'Bonus 6: Scripts de retención listos'
              }, {
                label: 'Tu posición en el club',
                bad: '"El que tira la pelota"',
                good: 'El DT con sistema profesional'
              }].map((row, i) => <tr key={i} className="border-b border-gray-100 last:border-0 hover:bg-gray-50" data-id="element-254">
                    <td className="p-4 font-medium text-gray-900" data-id="element-255">
                      {row.label}
                    </td>
                    <td className="p-4 text-center text-red-600 bg-red-50/30" data-id="element-256">
                      {row.bad}
                    </td>
                    <td className="p-4 text-center text-green-700 font-medium bg-green-50/30" data-id="element-257">
                      {row.good}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <p className="text-center text-xl text-gray-600 mt-8 italic" data-id="element-258">
            El lunes podés improvisar o entrar con todo resuelto. Vos decidís.
          </p>
        </div>
      </section>

      {/* SECCIÓN 10 — TESTIMONIOS COMPLETOS */}
      <section className="py-20 bg-white px-4" data-id="element-259">
        <div className="max-w-6xl mx-auto" data-id="element-260">
          <div className="text-center mb-16" data-id="element-261">
            <h2 className="text-4xl font-black text-gray-900 mb-4" data-id="element-262">
              Lo que dicen los entrenadores
            </h2>
            <div className="flex items-center justify-center gap-2 text-2xl font-bold text-gray-900" data-id="element-263">
              4.9/5 <Star className="w-6 h-6 text-yellow-400 fill-yellow-400" data-id="element-264" />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-265">
            {[{
            init: 'MP',
            name: 'Martín P.',
            city: 'Buenos Aires 🇦🇷',
            text: 'Compré un sábado. El domingo a la noche tenía el mes de clases listo. Nunca más improviso.'
          }, {
            init: 'CG',
            name: 'Carlos G.',
            city: 'Córdoba 🇦🇷',
            text: 'Tres alumnos de inicial que estaban estancados mejoraron el bote en el primer mes con el Tomo 1. Los padres me lo agradecieron.'
          }, {
            init: 'FR',
            name: 'Federico R.',
            city: 'Rosario 🇦🇷',
            text: 'Antes tardaba una hora armando cada práctica. Ahora son 5 minutos y la clase es mejor que antes.'
          }, {
            init: 'SV',
            name: 'Sofía V.',
            city: 'Mendoza 🇦🇷',
            text: 'El Nivelómetro 360 me cambió la vida. Antes mezclaba niveles sin querer. Ahora cada alumno está exactamente donde tiene que estar.'
          }, {
            init: 'DA',
            name: 'Diego A.',
            city: 'Santa Fe 🇦🇷',
            text: 'El Tomo 12 me salvó cuando una alumna vino con una hernia. Supe exactamente qué hacer y qué no. Eso no tiene precio.'
          }, {
            init: 'CR',
            name: 'Claudia R.',
            city: 'Tucumán 🇦🇷',
            text: 'El Ebook Elite 2 me dio las herramientas para armar mi primer equipo competitivo. Llegamos a la final del torneo zonal.'
          }].map((test, i) => <div key={i} className="bg-blue-50 p-6 rounded-2xl border border-blue-100" data-id="element-266">
                <div className="flex items-center gap-4 mb-4" data-id="element-267">
                  <div className="w-12 h-12 bg-blue-200 rounded-full flex items-center justify-center font-bold text-blue-800 text-lg" data-id="element-268">
                    {test.init}
                  </div>
                  <div data-id="element-269">
                    <div className="font-bold text-gray-900" data-id="element-270">{test.name}</div>
                    <div className="text-sm text-gray-500" data-id="element-271">{test.city}</div>
                  </div>
                </div>
                <div className="flex text-yellow-400 mb-3" data-id="element-272">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-273" />)}
                </div>
                <p className="text-gray-700 italic" data-id="element-274">"{test.text}"</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECCIÓN 11 — GARANTÍA */}
      <section className="py-20 bg-green-800 text-white px-4" data-id="element-275">
        <div className="max-w-3xl mx-auto text-center" data-id="element-276">
          <ShieldCheck className="w-20 h-20 mx-auto mb-6 text-green-400" data-id="element-277" />
          <h2 className="text-4xl font-black mb-8" data-id="element-278">
            Garantía 7 días sin preguntas
          </h2>

          <div className="text-xl text-green-100 space-y-4 mb-10 font-medium" data-id="element-279">
            <p data-id="element-280">
              Abrí los 12 Tomos. Revisá los 6 Bonus. Usá los Ebooks Elite en tu
              entrenamiento.
            </p>
            <p data-id="element-281">
              Si no es lo que esperabas →{' '}
              <span className="text-white font-bold bg-green-700 px-2 py-1 rounded" data-id="element-282">
                100% de devolución.
              </span>
            </p>
            <p data-id="element-283">Sin preguntas. Sin formularios. Sin drama.</p>
          </div>

          <div className="inline-block border border-green-600 bg-green-900/50 rounded-full px-6 py-2 text-sm font-bold tracking-widest uppercase text-green-300" data-id="element-284">
            TASA DE DEVOLUCIONES MENOR AL 2%
          </div>
        </div>
      </section>

      {/* SECCIÓN 12 — FAQ */}
      <section className="py-20 bg-white px-4" data-id="element-285">
        <div className="max-w-3xl mx-auto" data-id="element-286">
          <h2 className="text-4xl font-black text-center text-gray-900 mb-12" data-id="element-287">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-2" data-id="element-288">
            <FAQItem question="¿Cómo recibo el material?" answer="Al completar el pago recibís un email con el acceso inmediato a todos los PDFs. En menos de 5 minutos tenés todo descargado en tu celular o computadora." data-id="element-289" />
            <FAQItem question="¿Sirve si soy profe nuevo o si tengo experiencia?" answer="Sirve para los dos. Si sos nuevo, te da la estructura que necesitás para empezar con el pie derecho. Si ya tenés experiencia, te ahorra horas de planificación y te ordena lo que ya sabés." data-id="element-290" />
            <FAQItem question="¿Los 6 Bonus están en las dos opciones?" answer="Sí. Los 6 Bonus están incluidos en los 3 packs sin costo adicional. Los Ebooks Elite son exclusivos del Megapack Elite." data-id="element-291" />
            <FAQItem question="¿Qué diferencia hay con otros materiales de básquet que ya existen?" answer="La mayoría de los materiales son en inglés, son genéricos o son solo listas de ejercicios sin progresión. BÁSQUET 360 está diseñado específicamente para el entrenador amateur argentino, con sesiones listas para usar, graficadas y ordenadas semana a semana." data-id="element-292" />
            <FAQItem question="¿Sirve para grupos con niveles mezclados?" answer="Sí. El Bonus 1 (Nivelómetro 360) está diseñado exactamente para ese problema. En 5 minutos sabés en qué nivel está cada alumno y qué Tomo corresponde." data-id="element-293" />
            <FAQItem question="¿Qué pasa si no me sirve?" answer="Tenés 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% del dinero sin preguntas." data-id="element-294" />
            <FAQItem question="¿Vale la pena el Megapack Elite si ya planifico bien mis clases?" answer="Si ya planificás bien, el Elite 1 te libera horas de trabajo cada semana. El Elite 2 te da las herramientas para competir y para que tu trabajo empiece a tener resultados visibles en torneos. La mayoría de los que ya planifican bien son los que más valoran el sistema." data-id="element-295" />
            <FAQItem question="¿Puedo pagar con tarjeta de crédito?" answer="Sí. Aceptamos todas las tarjetas de crédito y débito, transferencia bancaria y Mercado Pago." data-id="element-296" />
          </div>
        </div>
      </section>

      {/* SECCIÓN 13 — CTA FINAL */}
      <section className="py-24 bg-slate-900 text-white px-4 text-center relative overflow-hidden" data-id="element-297">
        <div className="absolute inset-0 opacity-10 bg-[url('https://images.unsplash.com/photo-1546519638-68e109498ffc?auto=format&fit=crop&w=1000&q=45')] bg-cover bg-center" data-id="element-298"></div>
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-299">
          <div className="text-4xl mb-6" data-id="element-300">🏀</div>
          <h2 className="text-3xl md:text-5xl font-black mb-6 leading-tight" data-id="element-301">
            BÁSQUET 360 — El sistema de planificación N°1 para entrenadores de
            básquet argentinos.
          </h2>
          <p className="text-xl md:text-2xl text-gray-400 italic mb-12" data-id="element-302">
            "Porque preparar un buen entrenamiento no debería costarte todas las
            noches de la semana."
          </p>

          <a href="#pricing" onClick={scrollToPricing} className="inline-flex items-center justify-center gap-3 bg-orange-500 hover:bg-orange-600 text-white font-black text-xl md:text-2xl py-5 px-10 rounded-xl transition-all transform hover:scale-105 shadow-[0_0_40px_rgba(249,115,22,0.4)] w-full md:w-auto mb-8" data-id="element-303">
            🏀 QUIERO MI BÁSQUET 360 AHORA
          </a>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400" data-id="element-304">
            <span className="flex items-center gap-2" data-id="element-305">
              <ShieldCheck className="w-4 h-4" data-id="element-306" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-307">
              <CheckCircle2 className="w-4 h-4" data-id="element-308" /> Pago seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-309">
              <Clock className="w-4 h-4" data-id="element-310" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-2" data-id="element-311">
              <ShoppingCart className="w-4 h-4" data-id="element-312" /> Tarjetas y transferencia
            </span>
          </div>
        </div>
      </section>

      {/* PIE DE PÁGINA */}
      <footer className="bg-black text-gray-500 py-12 px-4 text-center text-sm" data-id="element-313">
        <div className="max-w-4xl mx-auto" data-id="element-314">
          <div className="text-xl font-black text-white mb-6" data-id="element-315">
            🏀 BÁSQUET 360™
          </div>
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-8" data-id="element-316">
            <span data-id="element-317">📧 contacto@basquet360.com.ar</span>
            <span data-id="element-318">📲 @basquet360.ar</span>
            <span data-id="element-319">🌐 www.basquet360.ar</span>
          </div>
          <p data-id="element-320">
            © BÁSQUET 360™ 2025 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </footer>
    </div>;
}